import { PsychedelicVisualizer, TeslaCoilVisualizer, TunnelVisualizer, OffVisualizer, ParticlesVisualizer } from './visualizers';

/**
 * SimulatedAudioVisualizer - Wrapper class that uses visualizers
 * Maintains backwards compatibility with existing interface
 */
export class SimulatedAudioVisualizer {
  private visualizer: PsychedelicVisualizer | TeslaCoilVisualizer | TunnelVisualizer | OffVisualizer | ParticlesVisualizer;

  constructor(canvas: HTMLCanvasElement, type: 'psychedelic' | 'tesla' | 'tunnel' | 'off' | 'particles' = 'tesla') {
    if (type === 'tesla') {
      this.visualizer = new TeslaCoilVisualizer(canvas);
    } else if (type === 'tunnel') {
      this.visualizer = new TunnelVisualizer(canvas);
    } else if (type === 'off') {
      this.visualizer = new OffVisualizer(canvas);
    } else if (type === 'particles') {
      this.visualizer = new ParticlesVisualizer(canvas);
    } else {
      this.visualizer = new PsychedelicVisualizer(canvas);
    }
  }

  updateAnalysisData(data: {
    beat: number;
    bar: number;
    energy: number;
    loudness: number;
    pitches: number[];
  }): void {
    this.visualizer.updateAnalysisData(data);
  }

  start(): void {
    this.visualizer.start();
  }

  stop(): void {
    this.visualizer.stop();
  }

  destroy(): void {
    this.visualizer.destroy();
  }
  
  startIntro(): void {
    this.visualizer.startIntro();
  }
  
  pause(): void {
    this.visualizer.pause();
  }
  
  resume(): void {
    this.visualizer.resume();
  }
  
  setTrackInfo(trackName: string, artistName: string): void {
    if (this.visualizer instanceof OffVisualizer) {
      this.visualizer.setTrackInfo(trackName, artistName);
    }
  }
}
